import React from 'react';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { TEST_ORDER_SCENARIO } from '../../../../../config';
import SelectComponent from '../../../../common/Select';
import { showModal } from '../../../../../actions/modal';
import { fetchPostOrderYamarketTest } from '../../../../../actions/admin';
import { useAutoTranslation } from '../../../../../helpers/useAutoTranslation';

const ExecuteYMTestScenario = ({ currentOrderId, actualizeOrder }) => {
  const dispatch = useDispatch();

  const { t } = useAutoTranslation();

  const [testScenario, setTestScenario] = useState(TEST_ORDER_SCENARIO[0]);

  const handleRequestOrderYamarketTest = async (testNum) => {
    const testData = {
      id: currentOrderId,
      testNum,
    };

    try {
      await dispatch(fetchPostOrderYamarketTest(testData));
      await actualizeOrder(currentOrderId);
    } catch (error) {}
  };

  const handleChangeScenario = (option) => {
    setTestScenario(option);

    if (option.value) {
      dispatch(
        showModal('ConfirmYMTestScenario', {
          submitCallback: () => handleRequestOrderYamarketTest(option.value),
          title: `${t('Заказ')} #${currentOrderId}`,
          actionName: t('Да'),
          content: (
            <p>
              {t('Данное действие выполнит тестовый сценарий')} <b>"{t(option.label)}"</b>.{' '}
              {t('Подтверждаете')}?
            </p>
          ),
        }),
      );
    }
  };

  return (
    <SelectComponent
      label={t('Выполнить ЯМ Тест сценарий')}
      options={TEST_ORDER_SCENARIO}
      value={testScenario}
      isClearable={false}
      onChange={(option) => handleChangeScenario(option)}
    />
  );
};

export default ExecuteYMTestScenario;
